module.exports = __webpack_public_path__ + "static/media/winterwizardjam.2adc5bd3.png";